<template>
<td colspan="1">

<button v-if="sifrant" class="k-button k-secondary k-mr-1" v-for="element in list" :title="title(element)">
    {{naziv(element)}}</button>
<button v-if="!sifrant" class="k-button k-secondary k-mr-1" v-for="element in list" :title="element">
    {{simple?element:element[displayname]}}</button>


</td>
</template>
<script>
export default {
  props: {
   list:Array,
   displayname:String,
   dataitemname:String,
   hover:String,
   sifrant:Array,
   sifrantid:String,
    dataItem: Object,
    simple:Boolean
    
  },
  created(){
    if(this.dataitemname)
      {    
        if(this.sifrant)
          this.dataItem[this.dataitemname]=this.sifrant.filter(s=>this.list.includes(s?.[this.sifrantid])).map(e=>e?.[this.displayname]).join(',');
        else
          this.dataItem[this.dataitemname]=this.list.map(e=>this.simple?e:e[this.displayname]).join(',');

      
      }
  },
  methods :{
    naziv: function (element){
    return this.sifrant.find(s=>s?.[this.sifrantid]==element)?.[this.displayname]
    },
      title: function(element){
          
          return this.sifrant.find(s=>s?.[this.sifrantid]==element)?.[this.hover];

      }
  },
  computed: {
    icon(){
      return this.checked?"check":"times";
    },
    spanClass() {
      return {
       'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!this.checked,"action_success":this.checked
        
      };
    }
  }
};
</script>